interface TFLayoutHeroProps {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const TFLayoutHero = ({ icon, title, description }: TFLayoutHeroProps) => {
  return (
    <div className="text-center">
      {/* <div className="inline-flex items-center justify-center w-14 h-14 [&>*]:text-black/30">
        {icon}
      </div> */}
      <h1 className="text-5xl font-light text-slate-900 leading-relaxed mb-8">
        {title}
      </h1>
      {/* <p className="text-slate-600 max-w-2xl mx-auto text-base mt-2">
        {description}
      </p> */}
    </div>
  );
};

export default TFLayoutHero;
